var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerifyEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 182,
    viewBox: "0 0 153 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4818 181.5C48.4934 181.5 62.284 161.878 62.284 137.673C62.284 113.468 48.4934 93.8462 31.4818 93.8462C14.4703 93.8462 0.679688 113.468 0.679688 137.673C0.679688 161.878 14.4703 181.5 31.4818 181.5Z",
    fill: "#0681DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4818 180.5C51.4934 180.5 65.284 160.878 65.284 136.673C65.284 112.468 51.4934 92.8462 34.4818 92.8462C17.4703 92.8462 3.67969 112.468 3.67969 136.673C3.67969 160.878 17.4703 180.5 34.4818 180.5Z",
    fill: "#149DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8498 87.7551C38.8498 87.7551 36.9247 84.5365 35.1574 84.3786C33.3902 84.2207 12.3491 97.4259 9.13053 104.299C5.91195 111.173 2.86633 124.964 11.3865 138.237C19.6962 151.149 32.7209 150.721 39.474 150.074C46.227 149.427 50.754 147.231 57.5973 141.742C64.4405 136.252 70.7198 128.168 71.6297 122.678C72.5396 117.189 69.1932 114.135 67.0575 113.376C64.9218 112.616 52.5664 112.767 43.5649 103.6C34.5634 94.4329 38.8498 87.7551 38.8498 87.7551Z",
    fill: "#06E8E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.581 83.5742C41.581 83.5742 36.1215 85.6648 32.745 89.3571C29.3685 93.0495 27.2854 98.8399 27.1275 107.353C26.9696 115.865 29.6993 125.499 40.2951 129.68C50.8908 133.861 60.3736 130.642 63.4268 127.747C66.4799 124.852 70.1948 116.67 70.1948 116.67C70.1948 116.67 53.3349 121.182 45.3034 111.684C37.272 102.186 41.581 83.5742 41.581 83.5742Z",
    fill: "#A0FAF8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.944 89.5074C131.823 83.3259 121.987 81.4985 114.211 78.9793C106.435 76.4601 101.856 71.4593 103.916 59.0812C105.977 46.7032 116.7 26.5946 116.497 22.9324C116.294 19.2701 79.4382 19.5032 76.0016 20.6763C72.5649 21.8495 71.8881 21.5863 68.6846 25.7073C66.9092 27.9328 65.3029 30.2881 63.8792 32.7535L67.8498 24.4063H68.1431C68.5746 23.3092 69.1872 22.2924 69.9554 21.3983C73.4496 17.3447 75.4296 12.2046 75.5579 6.85447C75.7083 -1.01902 70.1059 -0.25949 69.0455 2.16197C67.9852 4.58343 61.7812 12.9156 59.9613 15.1867C58.1415 17.4578 54.3589 23.6693 54.3589 23.6693L50.1552 38.2432C50.1552 38.2432 49.2377 42.5898 43.9737 59.0662C38.7096 75.5427 41.0032 83.1379 41.0032 83.1379C41.0032 83.1379 39.6271 82.4536 36.4235 92.2898C33.22 102.126 34.5962 114.707 40.3114 120.655C46.0266 126.604 53.5843 126.378 62.0519 122.949C67.2607 120.717 71.5988 116.847 74.4073 111.925C74.4073 111.925 83.3336 109.669 89.9663 104.608C96.599 99.5467 101.63 94.3127 111.256 94.7714C120.881 95.2302 131.845 100.72 135.508 100.487C139.17 100.254 140.065 95.6814 135.944 89.5074Z",
    fill: "#FC754B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M136.071 100.434C136.071 100.434 136.552 98.5089 131.093 95.922C125.633 93.3351 123.385 95.1174 123.385 96.4033C123.385 97.6892 135.229 100.434 136.071 100.434Z",
    fill: "#FCB199"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3392 12.3214L70.5625 22.9247H89.0393C89.0393 22.9247 89.0393 9.89994 84.3392 12.3214Z",
    fill: "url(#paint0_linear_28872_101109)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0664 107.202C58.3295 106.554 57.6408 105.853 57.0059 105.104",
    stroke: "#F0724A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7031 111.925C69.698 112.408 65.6516 111.528 62.1484 109.413",
    stroke: "#F0724A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M123.918 22.0149H54.493C44.9049 22.0149 37.1367 29.4372 37.1367 38.559V71.2713C37.1367 79.2275 43.0099 85.8752 50.8458 87.477L47.4206 99.5721L64.1337 87.8755H123.918C133.499 87.8755 141.274 80.4532 141.274 71.3314V38.6192C141.274 29.4372 133.499 22.0149 123.918 22.0149Z",
    fill: "#0069B5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M125.918 22.0149H56.493C46.9049 22.0149 39.1367 29.4372 39.1367 38.559V71.2713C39.1367 79.2275 45.0099 85.8752 52.8458 87.477L49.1835 98.3134L66.1337 87.8755H125.918C135.499 87.8755 143.274 80.4532 143.274 71.3314V38.6192C143.274 29.4372 135.499 22.0149 125.918 22.0149Z",
    fill: "#048FF3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4395 44.0413H128.483",
    stroke: "white",
    strokeWidth: 2.06409,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4395 52.0801H128.483",
    stroke: "white",
    strokeWidth: 2.06409,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4395 60.1116H128.483",
    stroke: "white",
    strokeWidth: 2.06409,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4395 68.1428H128.483",
    stroke: "white",
    strokeWidth: 2.06409,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M151.821 41.4465C151.821 46.2532 147.734 50.1886 142.643 50.1886C137.552 50.1886 133.465 46.2532 133.465 41.4465C133.465 36.6398 137.552 32.7043 142.643 32.7043C147.734 32.7043 151.821 36.6398 151.821 41.4465Z",
    fill: "white",
    stroke: "#048FF3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M141.892 47.974C141.574 47.3386 141.431 46.6299 141.478 45.921V38.4009L139.779 39.3485C139.596 39.4543 139.388 39.5112 139.177 39.5139C139.019 39.5155 138.862 39.4835 138.716 39.42C138.571 39.3565 138.441 39.2629 138.335 39.1454C138.113 38.9154 137.992 38.6073 137.996 38.2881C137.991 38.0712 138.054 37.8582 138.177 37.679C138.352 37.4691 138.561 37.2888 138.793 37.1451L142.087 35.4606C142.455 35.1968 142.885 35.0335 143.336 34.9868C144.456 34.9868 145.013 35.8291 145.013 37.5136V46.1842C145.013 47.8311 144.426 48.6508 143.245 48.6508C142.979 48.6742 142.712 48.6234 142.473 48.5039C142.234 48.3844 142.033 48.201 141.892 47.974Z",
    fill: "#048FF3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.51 17.1721C105.51 17.1721 105.818 23.2257 111.27 26.1059C116.722 28.9861 123.686 28.3619 123.836 24.7448C123.987 21.1277 119.745 17.3225 116.873 12.4721C114 7.62163 107.63 10.3589 104.908 13.6903",
    fill: "url(#paint1_linear_28872_101109)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M114.902 22.015C114.443 24.4365 116.112 25.7751 117.624 26.5271C119.135 27.2791 122.136 26.8354 123.835 24.7147C123.911 22.94 122.94 21.1352 121.579 19.1875C119.684 19.4281 115.255 20.12 114.902 22.015Z",
    fill: "#FCB199"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1521 17.172C94.1521 17.172 94.4529 23.2257 99.9049 26.1059C105.357 28.986 112.328 28.3619 112.478 24.7447C112.629 21.1276 108.388 17.3224 105.507 12.472C102.627 7.62157 96.2727 10.3589 93.543 13.6903",
    fill: "url(#paint2_linear_28872_101109)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M103.546 22.015C103.087 24.4365 104.757 25.7751 106.268 26.5271C107.78 27.2791 110.78 26.8354 112.48 24.7147C112.548 22.94 111.577 21.1352 110.224 19.1875C108.329 19.4281 103.899 20.12 103.546 22.015Z",
    fill: "#FCB199"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5876 17.172C83.5876 17.172 83.8884 23.2257 89.3405 26.1059C94.7925 28.986 101.756 28.3619 101.907 24.7447C102.057 21.1276 97.8231 17.3224 94.9429 12.472C92.0627 7.62157 85.7008 10.3589 82.9785 13.6903",
    fill: "#FC754B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9737 22.015C92.5225 24.4365 94.1844 25.7751 95.7035 26.5271C97.2225 27.2791 100.216 26.8354 101.908 24.7147C101.983 22.94 101.013 21.1352 99.6515 19.1875C97.7565 19.4281 93.3271 20.12 92.9737 22.015Z",
    fill: "#FCB199"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M41.002 83.6265C41.002 83.6265 41.4231 92.6441 46.5593 98.7118",
    stroke: "#F0724A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9682 122.322C26.9682 124.218 25.7048 125.752 24.1481 125.752C22.5915 125.752 21.3281 124.248 21.3281 122.322C21.3281 120.397 22.5915 118.893 24.1481 118.893C25.7048 118.893 26.9682 120.427 26.9682 122.322Z",
    fill: "#14ACA8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0502 121.994C26.0502 123.889 24.7868 125.423 23.2302 125.423C21.6735 125.423 20.4102 123.919 20.4102 121.994C20.4102 120.069 21.6735 118.565 23.2302 118.565C24.7868 118.565 26.0502 120.099 26.0502 121.994Z",
    fill: "#A0FAF8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6752 126.641C19.6752 128.536 18.4118 130.07 16.8552 130.07C15.2985 130.07 14.0352 128.566 14.0352 126.641C14.0352 124.716 15.2985 123.204 16.8552 123.204C18.4118 123.204 19.6752 124.746 19.6752 126.641Z",
    fill: "#14ACA8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0346 126.265C19.0346 128.16 17.7712 129.694 16.2146 129.694C14.6579 129.694 13.3945 128.19 13.3945 126.265C13.3945 124.34 14.6579 122.829 16.2146 122.829C17.7712 122.829 19.0346 124.37 19.0346 126.265Z",
    fill: "#A0FAF8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28872_101109",
    x1: 73.1859,
    y1: 21.6837,
    x2: 87.4886,
    y2: 18.3031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.556825,
    stopColor: "#FC754B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE6814"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28872_101109",
    x1: 114.374,
    y1: 9.84448,
    x2: 114.374,
    y2: 27.9185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC754B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED702A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28872_101109",
    x1: 103.013,
    y1: 9.84442,
    x2: 103.013,
    y2: 27.9184,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC754B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E36842"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerifyEmail);
export default __webpack_public_path__ + "static/media/verify-email.9d396666309dabeea2b620d170cb8ffc.svg";
export { ForwardRef as ReactComponent };